import appModuleRegistry from "components/appModules/appModuleRegistry";
import * as message from "components/message/message";
import sislogUserGlobals from "components/UserGlobals";
import $ from "jquery";
import * as queryString from "lib/queryString/queryString";
import { Action, ActionDefinition, isBrowseActionDefinition, isServerActionDefinition } from "./actions";
import { Cursor } from "./cursor";
import { registerAjaxTransport } from "./customAjaxTransport";
import { DefaultResponseAction } from "./defaultResponseAction";
import { getErrorCallback } from "./errorCallback";

registerAjaxTransport();

class ServerActionRequest {
    private static _xhr: JQueryXHR;

    private static _xhrs: { [actionName: string]: JQueryXHR } = {};
    private action: Action;

    constructor(action: Action) {
        this.action = action;
    }

    public serverAcceptCallback = (extraData: any) => {
        const definition = this.action.definition;
        const actionName = definition.actionName + "#-#" + this.action.dataHolder?.definition.id;
        if (isBrowseActionDefinition(definition)) {
            window.location.href = definition.url;
        } else if (isServerActionDefinition(definition)) {
            let data = {...this.action._data, ...extraData};
            let ajaxdata: object | string = sislogUserGlobals.mergeEnvironment(data);
            let url = this.getUrl(definition);
            if (ServerActionRequest.isSingleBlocking(definition)) {
                if (ServerActionRequest._xhr && ServerActionRequest._xhr.readyState !== 4) {
                    message.show({ key: "Waiting for previous action, current action cancelled.", level: "warn" });
                    console.warn("Already running request ", ServerActionRequest._xhrs[actionName]);
                    return;
                }
            } else {
                if (ServerActionRequest._xhrs[actionName] && ServerActionRequest._xhrs[actionName].readyState !== 4) {
                    ServerActionRequest._xhrs[actionName].abort();
                    delete ServerActionRequest._xhrs[actionName];
                }
            }
            if (definition.httpMethod === "post") {
                ajaxdata = JSON.stringify(ajaxdata);
            } else {
                url = url + "?" + queryString.stringify(ajaxdata);
                ajaxdata = null;
            }
            let headers = {};
            Cursor.begin();
            let event = new CustomEvent(
                "sislogActionEvent",
                {
                    detail: {
                        phase: "begin",
                        action: this.action,
                    },
                });
            document.dispatchEvent(event);
            const ajax = $.ajax({
                dataType: "binary",
                converters: {
                    "json binary": true,
                },
                type: definition.httpMethod,
                url,
                data: ajaxdata,
                contentType: "application/json; charset=utf-8",
                method: definition.httpMethod,
                success: this.getSuccesCallback(this.action),
                error: getErrorCallback(this.action),
                headers,
            });
            if (ServerActionRequest.isSingleBlocking(definition)) {
                ServerActionRequest._xhr = ajax;
            } else {
                ServerActionRequest._xhrs[actionName] = ajax;
            }
        }
    }

    public getUrl(definition: ActionDefinition): string {
        if (isServerActionDefinition(definition)) {
            return appModuleRegistry.prefixUrl(definition.url);
        } else {
            return null;
        }
    }

    private getSuccesCallback(action: Action) {
        const defaultResponseAction = DefaultResponseAction.getCallBack(action);
        return (response, status, jqXHR) => {
            $(action).on("actionRetrieved", defaultResponseAction);
            $(action).trigger("actionRetrieved", [this.action, response, jqXHR]);
            $(action).off("actionRetrieved", defaultResponseAction);
            $(action).trigger("actionPerformed", [this.action, response, jqXHR]);
        }
    }

    public static clearFisnished(actionDefinition: ActionDefinition): void {
        if (isServerActionDefinition(actionDefinition)) {
            if (ServerActionRequest.isSingleBlocking(actionDefinition)) {
                ServerActionRequest._xhr = null;
            } else {
                delete ServerActionRequest._xhrs[actionDefinition.actionName];
            }
        }
    }

    private static isSingleBlocking(definition)  {
        return (definition.httpMethod === "post" && definition.queueBehaviour == null || definition.queueBehaviour === "singleBlocking")
    }
}
const getServerAcceptCallback = (action: Action) => {
    const serverAcceptCallback = new ServerActionRequest(action);
    return serverAcceptCallback.serverAcceptCallback;
};

export { getServerAcceptCallback, ServerActionRequest };
